import Sidebar from '@view/layouts/Sidebar';
import { CloseButton, Loader } from '@view/components';
import React from 'react';
import { PatientInfo } from '@data/models';
import styles from './styles.scss';
import { cn } from '@utils';

type PatientInfoProps = {
  isOpen: boolean;
  onClose: () => void;
  patientInfo?: PatientInfo;
  upperStagesCount?: number;
  lowerStagesCount?: number;
  isLoading?: boolean;
};

const PatientInfoSidebar = ({
  isOpen,
  onClose,
  patientInfo,
  upperStagesCount,
  lowerStagesCount,
  isLoading,
}: PatientInfoProps) => {

  const getNumberOfAlignersString = () => {
    if (isLoading) {
      return <Loader size="md" />;
    }

    if (!upperStagesCount && !lowerStagesCount) {
      return '0/0';
    }

    const upper = upperStagesCount ? upperStagesCount : '0';
    const lower = lowerStagesCount ? lowerStagesCount : '0';

    return `${upper}/${lower}`;
  };

  return (
    <Sidebar className="z-[60]" isOpen={isOpen} size="sm">
      <div className={styles.patientInfo_header}>
        <span className={styles.patientInfo_headerTitle}>Patient Info</span>
        <CloseButton size="sm" onClick={onClose} />
      </div>
      <div className="px-4">
        <div className={styles.patientInfo_group}>
          <span className={styles.patientInfo_groupTitle}>First name</span>
          <span className={styles.patientInfo_groupDesc}>
            {patientInfo?.firstName}
          </span>
        </div>
        <div className={styles.patientInfo_group}>
          <span className={styles.patientInfo_groupTitle}>Last name</span>
          <span className={styles.patientInfo_groupDesc}>
            {patientInfo?.lastName}
          </span>
        </div>
        <div className={styles.patientInfo_group}>
          <span className={styles.patientInfo_groupTitle}>Case id</span>
          <span className={styles.patientInfo_groupDesc}>
            {patientInfo?.caseAliasId}
          </span>
        </div>
        <div className={styles.patientInfo_group}>
          <span className={styles.patientInfo_groupTitle}>
            Number of Aligners (U/L)
          </span>
          <span className={cn(styles.patientInfo_groupDesc, 'flex')}>
            {getNumberOfAlignersString()}
          </span>
        </div>
      </div>
    </Sidebar>
  );
};

export default PatientInfoSidebar;
